// language=HTML
const template = `
    <article class="booking-types">
        <md-content>
            <h1 class="md-display-2 section-title">Booking Types</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <md-card class="app-list-card" ng-if="installation.hasBookingTypes">
                <app-loading ng-if="fetching" layout-padding></app-loading>

                <md-list ng-if="!fetching">
                    <md-list-item ng-repeat="type in bookingTypes"
                                  class="md-2-line">
                        <md-icon class="md-avatar-icon">event_note</md-icon>

                        <div class="md-list-item-text">
                            <h3>{{ type.description }}</h3>

                            <p>
                                <small>Added <span am-time-ago="type.created_at"></span></small>
                            </p>
                        </div>
                    </md-list-item>
                </md-list>
            </md-card>

            <form autocomplete="off" name="form"
                  ng-submit="createBookingType($event)"
                  ng-disabled="creating">
                <md-card class="app-form-card">
                    <md-card-title>
                        <h2>Add a Booking Type</h2>
                    </md-card-title>

                    <md-card-content>
                        <booking-type-create-form
                            booking-type="newBookingType"
                            form="form">
                        </booking-type-create-form>
                    </md-card-content>

                    <md-card-actions layout="row" layout-align="end">
                        <md-button type="submit"
                                   class="md-raised md-primary"
                                   ng-disabled="creating || form.$invalid">
                            Create
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

BookingTypesController.$inject = [
    '$app',
    '$bookingTypeFetcher',
    '$errorHandler',
    '$installation',
    '$scope',
    '$state',
    '$util',
];

function BookingTypesController($app, $bookingTypeFetcher, $errorHandler, $installation, $scope, $state, $util) {
    $scope.installation = $installation;
    $scope.creating = false;
    $scope.fetching = false;
    $scope.newBookingType = {};

    $scope.createBookingType = createBookingType;

    fetchBookingTypes();

    function fetchBookingTypes() {
        $scope.fetching = true;

        $bookingTypeFetcher
            .all({
                order_by: 'created_at',
                direction: 'desc',
            })
            .then(
                response => {
                    $scope.bookingTypes = response.data;
                },
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                $scope.fetching = false;
            });
    }

    /**
     * Send the new carer booking type to the server.
     * @return {void}
     */
    function createBookingType() {
        $scope.creating = true;

        const toast = $app.progressToast('Creating booking type');

        const firstRun = !$installation.hasBookingTypes;

        $bookingTypeFetcher
            .create($scope.newBookingType)
            .then(
                $util.nextTick(result => {
                    $app.successToast('Booking type created!');

                    $scope.bookingTypes.push(result.data);
                    $scope.newBookingType = {};

                    $installation.hasBookingTypes = true;

                    if (firstRun) {
                        $state.go($installation.nextStep);
                    }
                }),
            )
            .catch(error => {
                $errorHandler.handle(error, $scope.form);
            })
            .finally(() => {
                $scope.creating = false;
                toast.hide();
            });
    }
}

export { template, BookingTypesController as controller };
